import { render, staticRenderFns } from "./Director.vue?vue&type=template&id=48a84d34&scoped=true&"
import script from "./Director.vue?vue&type=script&lang=js&"
export * from "./Director.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a84d34",
  null
  
)

export default component.exports